import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const GlobalReach = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const regions = [
    { name: 'North America', icon: 'ri-map-pin-line' },
    { name: 'South America', icon: 'ri-map-pin-line' },
    { name: 'Caribbean', icon: 'ri-map-pin-line' },
    { name: 'Africa', icon: 'ri-map-pin-line' },
    { name: 'Europe', icon: 'ri-map-pin-line' },
    { name: 'Asia', icon: 'ri-map-pin-line' },
    { name: 'Australia', icon: 'ri-map-pin-line' },
  ];

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
          >
            <div className="text-xs font-semibold text-primary-600 tracking-widest uppercase mb-4">
              WORLDWIDE DELIVERY
            </div>
            <h2 className="font-display font-light text-4xl md:text-5xl text-gray-900 mb-6">
              From Factory to Jobsite,{' '}
              <span className="font-semibold">Anywhere</span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Our global logistics network spans 156 countries with established partnerships at major ports worldwide. 
              We handle everything from factory pickup to final delivery, including customs documentation and clearance support.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {regions.map((region, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ delay: 0.3 + index * 0.1, duration: 0.5 }}
                  className="bg-gray-50 rounded-lg p-4 border border-gray-100"
                >
                  <div className="flex items-center space-x-2">
                    <div className="w-8 h-8 flex items-center justify-center bg-primary-100 rounded-lg">
                      <i className={`${region.icon} text-primary-600`}></i>
                    </div>
                    <h4 className="font-semibold text-sm text-gray-900">{region.name}</h4>
                  </div>
                </motion.div>
              ))}
            </div>

            <button className="px-6 py-3 border-2 border-primary-600 text-primary-600 text-sm font-medium rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer">
              View Coverage Areas
            </button>
          </motion.div>

          {/* Right - Map Visualization */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative bg-gradient-to-br from-primary-50 to-secondary-50 rounded-2xl p-8 lg:p-12">
              <img
                src="https://public.readdy.ai/ai/img_res/7a629fce024c6958b8ecbf4eb4febaea.jpg"
                alt="Global Coverage Map"
                className="w-full h-auto rounded-lg"
              />
              
              {/* Floating Stats */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="absolute top-8 right-8 bg-white rounded-lg shadow-lg p-4"
              >
                <div className="text-2xl font-bold text-primary-600">156+</div>
                <div className="text-xs text-gray-600">Major Ports</div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ delay: 0.7, duration: 0.5 }}
                className="absolute bottom-8 left-8 bg-white rounded-lg shadow-lg p-4"
              >
                <div className="text-2xl font-bold text-secondary-600">24/7</div>
                <div className="text-xs text-gray-600">Operations</div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default GlobalReach;